import classNames from 'classnames';
import { styles } from 'src/layouts/GenericScreenLayout/styles';

const MainContent = ({
  mainContent,
  hasBackground = false
}: {
  mainContent: JSX.Element;
  hasBackground?: boolean;
}) => {
  const { classes } = styles();
  return (
    <div className={classNames(classes.container, { [classes.isBackground]: hasBackground })}>
      {mainContent}
    </div>
  );
};
MainContent.displayName = 'MainContent';

export default MainContent;
